export type NullableString = string | boolean | undefined;

export const clc = (...classNames: NullableString[]) => {
	const result = classNames.filter((text): text is string => typeof text === 'string');

	if (result.length === 0) {
		return undefined;
	}
	return result.map((txt) => txt.trim()).join(' ');
};
